import {ignite} from "@ignitesales/neuro-application/src/ignite";
import extractPageFromPath from "@ignitesales/neuro-application/src/page/extractPageFromPath";

//TODO: remove this from decorating the state whenever we move answersWithPageInfo feature to neuro
const initState = async neuroState => {
  const currentPageRequest = extractPageFromPath(window.location.pathname);
  if( currentPageRequest.type === 'summary' || currentPageRequest.type === 'details') {
    const currentPageResponse = await ignite.pageResolutionService.loadPage({
      page: currentPageRequest
    });

    return {
      ...neuroState,
      answersWithPageInfo: extractAnswersWithPageInfo(currentPageResponse)
    }
  } else {
    return neuroState;
  }
};

const extractAnswersWithPageInfo = page => {
  const answersWithPageInfo = {};

  (page.answersWithPageInfo || []).forEach((answerObject, index) => {
    const answer = answerObject?.answer;
    const timestamp = answer?.timestamp ? new Date(answer?.timestamp) : new Date();
    answersWithPageInfo[answer.appkey] = {
      ...answer,
      timestamp,
      index,
      pathKey: answerObject?.pathKey,
      pageKey: answerObject?.pageKey
    };
  });

  return answersWithPageInfo;
};

export {
  initState as default,
  extractAnswersWithPageInfo
}
